module.exports = __webpack_public_path__ + "static/loading-ritual-white-8ea97b8468467dcc736705bad844a582.gif";